module.exports = __webpack_public_path__ + "static/media/d6kz.3a6b4964.pdf";